module.exports = {
	"articleTitle1": "The Slurping Turtle celebrates one year with Ramen Challenge ...",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Slurping Turtle",
	"articleLink1": "https://www.michigandaily.com/section/news/slurping-turtle-celebrates-one-year-ramen-challenge",
	"articleLink2": "https://www.michigandaily.com/news/new-noodle-shop-open-e-liberty",
	"articleSnippet1": "Aug 12, 2015 ... The Slurping Turtle, a new Japanese restaurant on East Liberty that also has a \nlocation in Chicago, celebrated its one-year anniversary Sunday ...",
	"articleSnippet2": "Feb 6, 2014 ... Foodies rejoice: Slurping Turtle, a new Japanese restaurant, expected to open in \nthe spring near campus. Takashi Yagihashi, a nationally ...",
	"foodRecommendations": [],
	"articleTitle2": "Slurping Turtle",
	"address": "608 E Liberty St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279164,
		"lng": -83.7415
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/slurpingturtle.json
// module id = 973
// module chunks = 0